import React, { Component } from "react";
import { observer } from "mobx-react";
import { delivery_connect_list } from "http/DetailConn";
import { toJS } from "mobx";
import {fn_devliery_connect_add_reset} from "function/FnBodyDelivery";
import {pay_free_yntype} from "../../../../http/SettingConn";

@observer
class DlvConnectResult extends Component {
  constructor(props) {
    super(props);
    this.inputFocus = React.createRef();
  }

  render() {
    const { rootStore } = this.props;
    const layerStore = rootStore.layerStore;

        return (
            <div className={"layer_comm layer_common_type alert" + (layerStore.getDlvConnectResultView ? ' layer_open' : '')}>
                <div className="bg"></div>
                <div className="layer_content">
                    <div className="wrap">
                        <div className="top">
                            <p>배달대행사 연동</p>
                        </div>
                        <div className="content_complete">
                            {
                                (rootStore.settingStore.getDlvConnectResult == "send") ?
                                    <>
                                        <div>
                                            <div className="baemin_img"></div>
                                            <p>연동 신청이 접수되었어요</p>
                                            <p className="small">연동 완료 시, 매장에 안내드리겠습니다</p>
                                            <p className="small">(1~2 영업일 소요)</p>
                                        </div>
                                    </>
                                    : (rootStore.settingStore.getDlvConnectResult == "confirm") ?
                                        <>
                                            <div>
                                                <div className="confirm_img"></div>
                                                <p>매장 정보 확인이 필요해요</p>
                                                <p>고객센터에 연락해주세요</p>
                                                <p className="small">1544-3583 (영업일 09:30~18:00)</p>
                                            </div>
                                        </>
                                        : (rootStore.settingStore.getDlvConnectResult == "complete") ?
                                            <>
                                                <div>
                                                    <div className={layerStore.getMappingAction ? "yogiyoConnect_img" : "yogiyoDisConnect_img"}></div>
                                                    <p>{rootStore.settingStore.getDlvRegistInfo.deliveryServiceName}과</p>
                                                    <p>연동이 완료되었어요!</p>
                                                </div>
                                            </>
                                            : <>
                                                <div>
                                                    <div className="yogiyofail_img"></div>
                                                    <p>매장 연동에 실패했어요</p>
                                                    <p>고객센터에 문의해주세요</p>
                                                    <p className="small">1544-3583 (영업일 09:30~18:00)</p>
                                                </div>
                                            </>
                            }
                        </div>
                        <div className="view_bottom">
                            <div>
                                <div className="divider"></div>
                            </div>
                            <div className="btn_complete">
                                <button
                                    onClick={event => {
                                        rootStore.settingStore.setDlvConnectResult("");
                                        rootStore.layerStore.setDlvConnectResultView(false);
                                        rootStore.deliveryStore.setDlvConnectCode([]);
                                        fn_devliery_connect_add_reset(rootStore);
                                        delivery_connect_list(rootStore);
                                        pay_free_yntype(rootStore);
                                    }}>확인</button>
                            </div>
                        </div>
                        <div className="btn_close btn_close_comm">
                            <button
                                onClick={event => {
                                    rootStore.settingStore.setDlvConnectResult("");
                                    rootStore.layerStore.setDlvConnectResultView(false);
                                    delivery_connect_list(rootStore);
                                }}
                            ><span>닫기</span></button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default DlvConnectResult;
